<template>
	<div class="recorder-comp">
		<div class="recorder-comp-wrap">
			<div class="recorder-comp-img">
				<img src="../assets/img/record-running.gif" alt="" v-if="recorder.status === 'start'">
				<img src="../assets/img/record-stop.png" alt="" v-else>
			</div>
		</div>
		<div class="recorder-comp-buttons" v-if="recorder.errorMsg === ''">
			<button @click="audioStart" v-if="recorder.status === 'init' || recorder.status === 'stop'">录音</button>
			<button class="recorder-comp-stop" @click="audioStop" v-if="recorder.status === 'start'">结束</button>
			<button class="recorder-comp-play" @click="audioPlay" v-if="recorder.status === 'stop'">试听</button>
			<button class="recorder-comp-send" @click="upload" v-if="recorder.status === 'stop'">确认</button>
		</div>
		<div class="recorder-comp-error" v-if="" v-html="recorder.errorMsg"></div>
		<audio id="recorder-comp-play" style="display: none;" :src="audioUrl"></audio>
	</div>
</template>

<script>
	export default{
		name:'RecorderComp',
		data(){
			return{
				recorderWorker: null, 
				recorder: {
					errorMsg: '',
					status: 'init',
					startTime: 0,
					endTime: 0
				},
				audioUrl:'',
				file: null
			}
		},
		methods:{
			// 初始化数据
			initData(){
				this.recorderWorker = null
				this.recorder = {
					errorMsg: '',
					status: 'init',
					startTime: 0,
					endTime: 0
				}
				this.audioUrl = ''
				this.file = null
			},
			
			// 录音开始
			audioStart(){
				this.recorder.startTime = (new Date()).getTime()
				this.recorder.start()
				this.recorder.status = 'start'	
			},
			
			// 录音结束
			audioStop(){
				let _this = this
				this.recorder.stop();
				this.recorder.getMp3Blob(function (blob) {
					let mp3Blob = blob;
					_this.audioUrl =  URL.createObjectURL(mp3Blob);
					_this.recorder.endTime = (new Date()).getTime()
					_this.recorder.status = 'stop'
					_this.file = new File([blob],new Date().getTime()+'.mp3')
				})
			},
			
			// 录音试听
			audioPlay(){
				document.getElementById("recorder-comp-play").play()
			},
			
			// 返回文件信息给父组件
			upload(){
				let duration = this.recorder.endTime - this.recorder.startTime
				if(duration < 0){
					return
				}
				this.$emit('recorder-call',{
					duration: duration,
					file: this.file
				})
				this.recorder.errorMsg = ''
				this.recorder.status = 'init'
				this.recorder.startTime = 0
				this.recorder.endTime = 0
				this.audioUrl = ''
				this.file = null
				
			},
			
			// 获取媒体对象，录音准备
			getRecorder(){
				let _this = this
				let config = {}
				config.sampleRate =  44100
				config.bitRate = 128
		
				navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia
		
				// 根据getUserMedia判断浏览器兼容性，并初始化录音
				if (navigator.getUserMedia) {
					navigator.getUserMedia({
						audio: true
					},
					// 成功回调
					function (stream) {
						let context = new AudioContext({
								latencyHint: "interactive",
								sampleRate: 24000
							}),
							microphone = context.createMediaStreamSource(stream),
							processor = context.createScriptProcessor(2048, 1, 1),//bufferSize大小，输入channel数，输出channel数
							mp3ReceiveSuccess, currentErrorCallback;
						config.sampleRate = context.sampleRate
						processor.onaudioprocess = function (event) {
							//边录音边转换
							let array = event.inputBuffer.getChannelData(0)
							_this.recorderWorker.postMessage({ cmd: 'encode', buf: array })
						};
		
						_this.recorderWorker = new Worker('/js/recorder/worker-realtime.js')
						_this.recorderWorker.onmessage = function (e) {
							switch (e.data.cmd) {
								case 'init':
									console.log('初始化成功');
									if (config.funOk) {
										config.funOk();
									}
									break;
								case 'end':
									console.log('MP3大小：', e.data.buf.length);
									if (mp3ReceiveSuccess) {
										mp3ReceiveSuccess(new Blob(e.data.buf, { type: 'audio/mp3' }));
									}
									break;
								case 'error':
									console.log('错误信息：' + e.data.error);
									if (currentErrorCallback) {
										currentErrorCallback(e.data.error);
									}
									break;
								default:
									console.log('未知信息：', e.data);
							}
						};
		
						_this.recorder.getMp3Blob = function (onSuccess, onError) {
							currentErrorCallback = onError;
							mp3ReceiveSuccess = onSuccess;
							_this.recorderWorker.postMessage({ cmd: 'finish' });
						};
		
						_this.recorder.start = function () {
							if (processor && microphone) {
								microphone.connect(processor);
								processor.connect(context.destination);
								console.log('开始录音');
							}
						}
		
						_this.recorder.stop = function () {
							if (processor && microphone) {
								microphone.disconnect();
								processor.disconnect();
								console.log('录音结束');
							}
						}
						
						_this.recorder.close = function () {
							context.close().then(()=>{
								console.log('上下文已关闭')
							})
						}
		
						// 初始化
						_this.recorderWorker.postMessage({
							cmd: 'init',
							config: {
								sampleRate: config.sampleRate,
								bitRate: config.bitRate
							}
						});
					},
					// 失败回调
					function (error) {
						let msg
						switch (error.code || error.name) {
							case 'PERMISSION_DENIED':
							case 'PermissionDeniedError':
								msg = '用户拒绝访问麦客风';
								break;
							case 'NOT_SUPPORTED_ERROR':
							case 'NotSupportedError':
								msg = '浏览器不支持麦客风';
								break;
							case 'MANDATORY_UNSATISFIED_ERROR':
							case 'MandatoryUnsatisfiedError':
								msg = '找不到麦客风设备';
								break;
							default:
								msg = '无法打开麦克风，异常信息:' + (error.code || error.name);
								break;
						}
						_this.recorder.errorMsg = msg
					})
				} else {
					_this.recorder.errorMsg = '当前浏览器不支持录音功能'
				}
			}
		},
		created() {
			this.initData()
			this.getRecorder()
		},
		destroyed() {
			if(this.recorderWorker !== null){
				this.recorderWorker.terminate()
			}
			if(this.recorder.stop !== undefined){
				this.recorder.stop()
			}
			if(this.recorder.close !== undefined){
				this.recorder.close()
			}
			
			this.initData()
		}
	}
</script>

<style>
	.recorder-comp-wrap{
		padding: 10px;
	}
	.recorder-comp-wrap .recorder-comp-img{
		width: 60px;
		height: 60px;
		margin: 0 auto;
	}
	.recorder-comp-img img{
		width: 100%;
		height: 100%;
	}
	.recorder-comp-buttons{
		text-align: center;
		padding: 10px 0;
	}
	.recorder-comp-buttons button{
		margin: 0 2px;
		background-color: #009E94;
		color: #FFFFFF;
		padding: 2px 8px;
		font-size: 12px;
		cursor: pointer;
		border-radius: 2px;
		margin-left: unset !important;
	}
	.recorder-comp-buttons .recorder-comp-stop{
		background-color: #ff5500;
	}
	.recorder-comp-buttons .recorder-comp-resume{
		background-color: #00aaff;
	}
	.recorder-comp-buttons .recorder-comp-pause{
		background-color: #ffaa00;
	}
	.recorder-comp-buttons .recorder-comp-play{
		background-color: #00aa00;
	}
	.recorder-comp-buttons .recorder-comp-send{
		background-color: #55aaff;
	}
	.recorder-comp-error{
		color: #ff4d30;
		font-size: 12px;
		text-align: center;
	}
</style>
